import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'stringToJson' })
export class StringToJson implements PipeTransform {
  transform(data: string) {
    return JSON.parse(data);
  }
}
